import Textbox from '@/Controls/Textbox.vue'
import TextArea from '@/Controls/TextArea.vue'
import Select from '@/Controls/Select.vue'
import CheckboxList from '@/Controls/CheckboxList.vue'
import RadioButtonList from '@/Controls/RadioButtonList.vue'
import RecordMoveButtons from '@/Controls/RecordMoveButtons.vue'
//import ConfirmDialog from '@/Controls/ConfirmDialog.vue'
import MessageWindow from '@/Controls/MessageWindow.vue'
import DatePicker from '@/Controls/DatePicker.vue'
import Label from '@/Controls/Label.vue'
import FileUpload from '@/Controls/FileUpload.vue'
import Link from '@/Controls/Link.vue'
import Back from '@/Controls/Back.vue'
import CheckBox from '@/Controls/CheckBox.vue'
import Password from '@/Controls/Password.vue'
import InputSelect from '@/Controls/InputSelect.vue'
import InputQuery from '@/Controls/InputQuery.vue'
import NumberInput from '@/Controls/NumberInput.vue'
import Button from '@/Controls/Button.vue'
import HtmlEditor from '@/Controls/HtmlEditor.vue'
import PictureUpload from '@/Controls/PictureUpload.vue'
import MultipleSelectBox from '@/Controls/MultipleSelectBox.vue'
import ListView from '@/Controls/ListView.vue'
import ListView2 from '@/Controls/ListView2.vue'
import ToggleButton from '@/Controls/ToggleButton.vue'
import Tab from '@/Controls/Tab.vue'
import SingleFileUpload from '@/Controls/SingleFileUpload.vue'
import MultiFileUpload from '@/Controls/MultiFileUpload.vue'
import Img from '@/Controls/Img.vue'
import Number from '@/Controls/Number.vue'
import Component from '@/Controls/Component.vue'

export {
    CheckBox,
    Textbox,
    TextArea,
    Select,
    CheckboxList,
    RadioButtonList,
    RecordMoveButtons,
    //ConfirmDialog,
    MessageWindow,
    DatePicker,
    Label,
    FileUpload,
    Link,
    Back,
    Password,
    InputSelect,
    InputQuery,
    NumberInput ,
    Button,
    HtmlEditor,
    PictureUpload,
    MultipleSelectBox,
    ListView,
    ListView2,
    ToggleButton,
    Tab,
    SingleFileUpload,
    MultiFileUpload ,
    Img,
    Number,
    Component,
}


export default {

    install: function (Vue, options) {
         

        Vue.component("t-checkboxlist", CheckboxList);
        Vue.component("t-radiobuttonlist", RadioButtonList);
        Vue.component("t-select", Select);
        Vue.component("t-textbox", Textbox);
        Vue.component("t-textarea", TextArea);
        //Vue.component("t-confirmdialog", ConfirmDialog);
        Vue.component("t-messagewindow", MessageWindow);
        Vue.component("t-datepicker", DatePicker);
        Vue.component("t-label", Label);
        Vue.component("t-link", Link);
        Vue.component("t-back", Back);
        Vue.component("t-fileupload", FileUpload);
        Vue.component("t-recordmovebuttons", RecordMoveButtons);
        Vue.component("t-checkbox", CheckBox);
        Vue.component("t-password", Password);
        Vue.component("t-inputselect", InputSelect);
        Vue.component("t-numberinput", NumberInput);
        Vue.component("t-button", Button);
        Vue.component("t-htmleditor", HtmlEditor);
        Vue.component("t-pictureupload", PictureUpload);
        Vue.component("t-inputquery", InputQuery);
        Vue.component("t-multipleselectbox", MultipleSelectBox);
        Vue.component("t-listview", ListView);
        Vue.component("t-listview2", ListView2);
        Vue.component("t-togglebutton", ToggleButton);
        Vue.component("t-tab", Tab);
        Vue.component("t-singlefileupload", SingleFileUpload);
        Vue.component("t-multifileupload", MultiFileUpload);
        
        Vue.component("t-img", Img);

        Vue.component("t-number", Number);

        Vue.component("t-component", Component);
        Vue.component("t-comp", Component);

    }
}
